if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);

        // Listen for global cart updates
        if (
          typeof subscribe === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }
      }

      onCartUpdate(event) {
        // If the update came from this form (adding to cart), we might not need to fetch immediately
        // but fetching ensures we have the absolute latest source of truth.
        // Fetch fresh cart data
        fetch(window.routes.cart_url + ".js?v=" + Date.now())
          .then((response) => response.json())
          .then((cart) => {
            if (!this.formInput) return;
            const variantId = parseInt(this.formInput.value);
            const cartItem = cart.items.find((item) => item.id === variantId);
            const cartQty = cartItem ? cartItem.quantity : 0;

            // Get limits
            const qtyInput = this.form.querySelector('[name="quantity"]');
            const addButton = this.submitButton;

            let inventoryLimit = 999;
            // Prioritize button data attribute as the single source of truth for buffer logic
            if (addButton && addButton.hasAttribute("data-inventory-limit")) {
              inventoryLimit = parseInt(
                addButton.getAttribute("data-inventory-limit")
              );
            } else if (
              qtyInput &&
              qtyInput.hasAttribute("data-inventory-limit")
            ) {
              inventoryLimit = parseInt(
                qtyInput.getAttribute("data-inventory-limit")
              );
            }

            // Calculate new max
            const newMax = Math.max(0, inventoryLimit - cartQty);

            // Update Quantity Input
            if (qtyInput) {
              qtyInput.setAttribute("max", newMax);
              if (parseInt(qtyInput.value) > newMax) {
                qtyInput.value = Math.max(1, newMax);
              }
              // Special case: if max is 0, we shouldn't allow being at 1?
              // actually logic above handles max(1, 0) -> 1.
              // But if sold out, disable button.
            }

            // Update Button State
            if (addButton) {
              if (newMax === 0) {
                addButton.setAttribute("disabled", "disabled");
                addButton.classList.add("disabled");
                const textSpan = addButton.querySelector(".submit-title");
                // Only update text if it's not "Coming Soon" or other permanent state?
                // The logic in main-product handles "limit reached" vs "sold out"
                // We'll stick to a simple "Limit Reached" if physically available but cart is full.
                if (textSpan) textSpan.innerText = "Limit Reached";
              } else {
                // Check if we should re-enable
                // We only re-enable if it was disabled due to limit reached.
                // Ideally we check if 'unavailable' text is present.
                // But here we can check the button text or disabled state.
                const textSpan = addButton.querySelector(".submit-title");
                const currentText = textSpan
                  ? textSpan.innerText
                  : addButton.innerText;

                if (
                  currentText === "Limit Reached" ||
                  addButton.hasAttribute("disabled")
                ) {
                  // Re-enable
                  addButton.removeAttribute("disabled");
                  addButton.classList.remove("disabled");
                  if (textSpan)
                    textSpan.innerText =
                      (window.variantStrings &&
                        window.variantStrings.addToCart) ||
                      "Add to Cart";
                }
              }
            }
          })
          .catch((e) => console.error(e));
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay"
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open"
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open"
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const quantityInput = this.form.querySelector('[name="quantity"]');
        const currentQty = quantityInput ? parseInt(quantityInput.value) : 1;
        const currentMax = quantityInput
          ? parseInt(quantityInput.getAttribute("max"))
          : 999;

        if (quantityInput && currentQty > currentMax) {
          this.handleErrorMessage(
            window.cartStrings.quantityError.replace("[quantity]", currentMax)
          );
          return;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                })
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Update Max Quantity dynamically after add
            if (quantityInput) {
              const newMax = Math.max(0, currentMax - currentQty);
              quantityInput.setAttribute("max", newMax);
              quantityInput.value = 1; // RESET to 1
              if (newMax === 0) {
                this.submitButton.setAttribute("disabled", "disabled");
                const submitTitle =
                  this.submitButton.querySelector(".submit-title");
                if (submitTitle) submitTitle.innerText = "Limit Reached"; // Or Sold Out
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true }
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on"
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container"
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay"
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader"
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open"
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open"
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay"
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
